module.exports = "/static-assets/_next/static/images/img-572c37a769-68ddf09cac4128797a2c110f47339224.webp";